module.exports = __webpack_public_path__ + "static/media/bubbles.c4f2ef94.gif";